import { MultiStepForm, UserProfileModel } from '@nw/fields-manager';
import { GetProductDetailsResponseType } from '@nw/shared/data-access';

import { BaseProductDetail } from './BaseProductDetail';
import { EMIInstallmentPricingDetails } from './EMIInstallmentPricingDetails';

interface EMIConfig {
  no_of_months: number;
  interest_rate: number;
}

export class EMIInstallmentProductDetail extends BaseProductDetail {
  readonly installmentType = 'EMI';
  readonly emiSelectionType = 'PRE_ORDER';
  readonly availableEMIConfigs: EMIConfig[];
  readonly initialPricingDetails: EMIInstallmentPricingDetails;
  currentPricingDetails: EMIInstallmentPricingDetails;

  constructor(
    productDetails: GetProductDetailsResponseType,
    userProfileDetails: UserProfileModel | null = null
  ) {
    super(productDetails);

    this.availableEMIConfigs =
      this.installmentPricingDetails?.available_emi_installment_configs || [];

    this.initialPricingDetails = new EMIInstallmentPricingDetails(
      productDetails
    );
    this.currentPricingDetails = this.initialPricingDetails;
    this.form = this.parsedUserExtraInfoConfig
      ? new MultiStepForm(
          this.parsedUserExtraInfoConfig.registration_form_details,
          userProfileDetails,
          this
        )
      : undefined;
  }

  shouldShowCouponApplyButton(): boolean {
    return (
      this.currentPricingDetails.amountToBePaid > 0 &&
      (this.parsedExtraData?.should_show_coupon_apply_button ?? true)
    );
  }

  updateCurrentDetailsWithReferralCodeResponse(
    pricingDetailsObject: EMIInstallmentPricingDetails
  ) {
    this.currentPricingDetails = pricingDetailsObject;
  }

  updateCurrentDetailsWithInitialPricingDetails() {
    this.currentPricingDetails = this.initialPricingDetails;
  }

  getEMIConfigByMonths(months: number): EMIConfig | undefined {
    return this.availableEMIConfigs.find(
      (config) => config.no_of_months === months
    );
  }

  get shouldShowCouponApplyButtonComputed(): boolean {
    const amountToBePaidInLeastSubUnit =
      this.currentPricingDetails.amountToBePaid;
    const maxReferralDiscountAmount =
      this.currentPricingDetails.referralDiscountValue;

    if (!amountToBePaidInLeastSubUnit) return false;
    else if (maxReferralDiscountAmount && maxReferralDiscountAmount > 0)
      return true;
    return true;
  }
}
